var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.4 490.4",
    style: {
      enableBackground: "new 0 0 490.4 490.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M345.9,0H144.5C64.8,0,0,64.8,0,144.5v201.4c0,79.7,64.8,144.5,144.5,144.5h201.4c79.7,0,144.5-64.8,144.5-144.5V144.5 C490.4,64.8,425.6,0,345.9,0z M458.2,345.9c0,61.9-50.4,112.3-112.3,112.3H144.5c-61.9,0-112.3-50.4-112.3-112.3V144.5 c0-61.9,50.4-112.3,112.3-112.3h201.4c61.9,0,112.3,50.4,112.3,112.3V345.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,117.8c-71.5,0-129.7,58.2-129.7,129.7s58.2,129.7,129.7,129.7S373.7,319,373.7,247.5S315.6,117.8,244.1,117.8z  M244.1,345c-53.7,0-97.5-43.7-97.5-97.5s43.7-97.5,97.5-97.5s97.5,43.7,97.5,97.5S297.8,345,244.1,345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,95c-10.4,0-18.8,8.4-18.8,18.8c0,10.4,8.4,18.8,18.8,18.8s18.8-8.4,18.8-18.8C400.5,103.4,392.1,95,381.7,95z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.f7d27d080bc73899f9d455a9813d81a9.svg";
export { ForwardRef as ReactComponent };